import { AiOutlineSetting } from 'react-icons/ai';


export const settingsType='settings'
export const settingsApi = '/settings'
export const settingsParam= 'settingsTab'
export const settingsParamValue= 'settings'
export const SettingsIcon = AiOutlineSetting